import { DomesticAddress } from '@shared/types'
import { COMMON_PLACEHOLDER } from '@ui-components/global/constants'
import { JSX } from 'react'

interface AddressProps {
  address: DomesticAddress
  showCountry: boolean
}

export const DomesticAddressFields = ({ address, showCountry = true }: AddressProps): JSX.Element => {
  return (
    <>
      <span>
        {address.street ?? COMMON_PLACEHOLDER}
        <br />
      </span>
      <span>
        {address.postalCode ?? COMMON_PLACEHOLDER} {address.postOffice ?? COMMON_PLACEHOLDER}
        <br />
      </span>
      {showCountry && (
        <span>
          {address.countryName ?? COMMON_PLACEHOLDER}
          <br />
        </span>
      )}
    </>
  )
}
